import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  partTitle: {
    fontWeight: 'bold',
    color: theme.palette.primary.dark,
    fontSize: 14,
  },
  chip: {
    marginBottom: 8,
    marginInlineEnd: 5,
    backgroundColor: theme.palette.primary.lighter,
    '&:focus': {
      backgroundColor: theme.palette.primary.light,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  btnChangeOwner: {
    '@media(min-width: 600px)': {
      marginTop: 31,
      width: 'auto',
    },
  },
  iconStyle: {
    border: '1px solid #ccc',
    borderRadius: '2px',
    padding: '2px',
    position: 'absolute',
    right: '24px',
    cursor: 'pointer',
  },
  agentRow: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  inquiryBox: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  btnChange: {
    margin: '32px',
    width:'100%',
    padding:'1px',
    [theme.breakpoints.down('sm')]: {
      margin:'0',
    },
    [theme.breakpoints.down('md')]: {
      
      width:'100% important',
    },
    [theme.breakpoints.up('sm')]: {
      width:'60%',
    },
    [theme.breakpoints.up('md')]: {
      width:'100%',
      fontSize:'12px'
    },
  },
  marginAllAgent: {
    margin: '0 8px',
  },

   
  captcha: {
    maxHeight: 60,
    maxWidth: '100%',
    borderRadius: 4,
    marginInlineStart: theme.spacing(1),
    marginTop: theme.spacing(3),
  },
  captchaLoading: {
    height: 85,
    width: 200,
    borderRadius: 4,
    marginInlineStart: theme.spacing(1),
    marginBottom: theme.spacing(-0.5),
  },

  customCaptchaDialog: {
    display: 'flex',
    gap: '15px',
    flexDirection: 'row-reverse',
    marginTop: '16px',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  captchaDialog: {
    maxHeight: 37,
    maxWidth: '100%',
    borderRadius: 4,
    marginInlineStart: theme.spacing(1),
    marginTop: theme.spacing(3),
  },
  captchaLoadingDialog: {
    height: 68,
    width: 150,
    borderRadius: 4,
    marginInlineStart: theme.spacing(1),
    marginTop: 10,
  },
  captchaBoxDialog: {
    display: 'flex',
    alignItems: 'center',
  },
  iconActionCaptchaDialog: {
    marginTop: 12
  }
}));
